const { DateTime } = require("luxon");
const { fbTsToDate } = require("../common/date");

function getTime(shift, type, firebase) {
  const startTime = shift.startTime;
  const endTime = shift.endTime;

  if (type === "start") {
    if (!startTime) return null;
    if (startTime?.hasOwnProperty("hour")) {
      const { hour, minute } = startTime;
      const dateTime = DateTime.local().set({
        hour,
        minute,
        second: 0,
        millisecond: 0,
      });
      return dateTime.toJSDate();
    } else return fbTsToDate(firebase, startTime);
  }

  if (type === "end") {
    if (!endTime) return null;
    if (endTime?.hasOwnProperty("hour")) {
      const { hour, minute } = endTime;
      const dateTime = DateTime.local().set({
        hour: hour <= startTime.hour ? hour + 24 : hour,
        minute,
        second: 0,
        millisecond: 0,
      });
      return dateTime.toJSDate();
    } else return fbTsToDate(firebase, endTime);
  }
}

function getDate(date, type, firebase) {
  const { day, year, month } = date;
  if (type === "start") {
    if (day && year && month) {
      const dateTime = DateTime.local()
        .set({ day, year, month })
        .startOf("day");
      return dateTime.toJSDate();
    } else return fbTsToDate(firebase, date);
  } else {
    if (day && year && month) {
      const dateTime = DateTime.local().set({ day, year, month }).endOf("day");
      return dateTime.toJSDate();
    } else return fbTsToDate(firebase, date);
  }
}

const hydrateShift = (shift, firebase) => ({
  ...shift,
  startTime: getTime(shift, "start", firebase),
  endTime: getTime(shift, "end", firebase),
  ...(shift.startDate && {
    startDate: getDate(shift.startDate, "start", firebase),
  }),
  ...(shift.endDate && { endDate: getDate(shift.endDate, "end", firebase) }),
  ...(shift.startDate &&
    !shift.endDate && {
      endDate: getDate(shift.startDate, "end", firebase),
    }),
});
module.exports = hydrateShift;
